import { render, staticRenderFns } from "./PrivateChatPage.vue?vue&type=template&id=a5d75356&scoped=true&"
import script from "./PrivateChatPage.vue?vue&type=script&lang=js&"
export * from "./PrivateChatPage.vue?vue&type=script&lang=js&"
import style0 from "./PrivateChatPage.vue?vue&type=style&index=0&id=a5d75356&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5d75356",
  null
  
)

export default component.exports